<template>
  <div class="page-wrapper">
    <header class="navbar">
      <img alt="Showadz logo" class="logo" src="@/assets/img/showadz-logo.svg" />
    </header>
    <h1 class="big-title">Privacy Policy</h1>
    <h2 class="small-title">Privacy Policy</h2>
    <p>
      This Privacy Policy governs the manner in which Showadz (Showadz, We, or Us) collects, uses, maintains and discloses Personal Information about users
      and customers (each, a User), as well as prospective customers, of the app.showadz.io website (Site) as well as Our online platform and related
      products and services (the Services).
    </p>
    <h2 class="small-title">Personal identification information</h2>
    <p>
      This Privacy Policy covers Our collection, use and disclosure of information about identifiable individuals and information which can be used to
      identify an individual (Personal Information).
    </p>
    <p>
      We may collect Personal Identification information from Users in a variety of ways, including, but not limited to, when Users visit Our site,
      register for Services, subscribe to the newsletter and in connection with other activities, Services, features or resources We make available on Our
      Site. Users may be asked for, as appropriate, name, phone number, address, email address and credit card and billing information.
    </p>
    <p>
      If a User communicates with Us by telephone, the call will be recorded for internal quality assurance. We may collect the Users name, phone number,
      or other Personal Information required to fulfill the purpose of the call.
    </p>
    <h2 class="small-title">Collection and Use of Personal Information</h2>
    <p class="regular-text">Showadz collects and uses Users Personal Information for the following purposes:</p>
    <ul>
      <li>Provide, operate, maintain and improve the Services;</li>
      <li>To improve customer service.</li>
      <li>Effectively respond to your customer service requests and support needs.</li>
      <li>To personalize User experience.</li>
      <li>To improve Our Site and Services.</li>
      <li>To process transactions.</li>
      <li>To administer a content, promotion, survey or other Site feature.</li>
      <li>To send Users information they agreed to receive about topics We think will be of interest to them.</li>
      <li>To send technical notices, updates, security alerts and support and administrative messages.</li>
    </ul>
    <p>
      The email address Users provide for order processing will be used to send information and updates pertaining to their order or other information
      related to the Services. It may also be used to respond to their inquiries, and/or other requests or questions. If User decides to opt-in to Our
      mailing list, they will receive emails that may include company news, updates, related product or service information, etc. If at any time the User
      would like to unsubscribe from receiving future emails, We include detailed unsubscribe instructions at the bottom of each email or User may contact
      Us via Our Site. However, Users may not unsubscribe from emails that are mandatory for the Services.
    </p>
    <p>
      We also collect data about how and when you access the Website and Service, including information about the device and browser you use, your network
      connection, your IP address, and information about how to interact with the Service.
    </p>
    <p>
      We use this information to give you access to and improve our Service. We also use this information to personalize the Service for you. Finally, we
      may use this information to provide you with advertising or marketing.
    </p>
    <h2 class="small-title">Social Media Insights</h2>
    <p>
      Showadz only collects insights that are available through the connected social networks’ official developer APIs to provide you with social media
      analytics reports.
    </p>
    <h2 class="small-title">Payment Information</h2>
    <p>
      We do not collect any credit card or other billing information. Instead purchases will be processed through a third-party payment processor. By using
      any third-party service, you agree to be bound by such third-partys terms and conditions and privacy policy.
    </p>
    <h2 class="small-title">Cookies</h2>
    <p>
      As you visit or browse the Website, We collect information about the device and browser you use, your network connection, your IP address, and
      information about the cookies installed on your device. This information is logged to help diagnose technical problems for analytics and for quality
      control purposes.
    </p>
    <p>
      Our Site may also use cookies to enhance User experience. A Users web browser places cookies on their hard drive for record-keeping purposes and
      sometimes to track information about them. The User may choose to set their web browser to refuse cookies, or to alert you when cookies are being
      sent. If they do so, note that some parts of the Site or Service may not function properly.
    </p>
    <p>
      Third parties, including Facebook, may use cookies, web beacons, and other storage technologies to collect or receive Personal Information from the
      Websites and elsewhere on the internet and use that information to provide measurement services and targeted ads. Note that we do not provide any
      interest-based advertising to individuals under 16 years old. Users can limit cookies used by their browsers and third parties by updating settings
      at:
      <a href="http://www.aboutads.info/choices">http://www.aboutads.info/choices</a> and
      <a href="http://www.youronlinechoices.eu">http://www.youronlinechoices.eu</a>.
    </p>
    <h2 class="small-title">Aggregated Non-Personal Information</h2>
    <p>
      We may use information in the aggregate (or that has otherwise been anonymized) to understand how Our Users as a group use the services and resources
      provided on Our Site.
    </p>
    <h2 class="small-title">Storage Location and Transfer of Personal Information</h2>
    <p>
      Showadz processes and stores its data, including Personal Information, on servers located in Canada and the United States. By submitting Personal
      Information or otherwise using the Services, you agree to this transfer, storing or processing of your Personal Information in Canada and the United
      States. You acknowledge and agree that your Personal Information may be accessible to law enforcement and governmental agencies in Canada and the
      U.S. under lawful access regimes or court order.
    </p>
    <p>
      We may from time to time employ third parties to perform tasks on Our behalf and We may need to share Personal Information with them. Unless We tell
      you differently, such third parties do not have any right to use the Personal Information We share with them beyond what is necessary for them to
      provide the tasks and services on Our behalf. The third parties We may engage include companies and individuals employed by Us to facilitate Our
      services, including the provision of maintenance services, database management, Web analytics, customer relationship management and general
      improvement of the Services.
    </p>
    <p>
      If Our business (or substantially all of Our assets) are acquired by a third party, or if We go out of business, enter bankruptcy, or go through some
      other change of control, Personal Information may be made available or otherwise transferred to the new controlling entity, where permitted under
      applicable law.
    </p>
    <p>
      If We need to use or disclose any Personal Information in a way not identified in this Privacy Policy, We will notify you and/or obtain consent as
      required under applicable privacy laws.
    </p>
    <h2 class="small-title">Disclosure Required by Law</h2>
    <p>
      We may disclose your Personal Information to third parties without your consent if We have reason to believe that disclosing this information is
      necessary to identify, contact or bring legal action against someone who may be causing injury to or interference with (either intentionally or
      unintentionally) Our rights or property, other Users, or anyone else (including the rights or property of anyone else) that could be harmed by such
      activities. Further, We may disclose Personal Information when We believe in good faith that such disclosure is required by and in accordance with
      the law. We also reserve the right to access, read, preserve, and disclose any information as We reasonably believe is necessary to:
    </p>
    <ul>
      <li>satisfy any applicable law, regulation, legal process or governmental request;</li>
      <li>enforce Our contracts or user agreement, including investigation of potential violations hereof; and</li>
      <li>detect, prevent, or otherwise address fraud, security or technical issues.</li>
    </ul>
    <p>
      The above may include exchanging information with other companies and organizations for fraud protection and spam/malware prevention. Notwithstanding
      the general terms of this policy, the collection, use, and disclosure of Personal Information may be made outside of the terms herein to the extent
      provided for in any applicable privacy or other legislation in effect from time to time, or pursuant to court orders.
    </p>
    <h2 class="small-title">Storage and Retention</h2>
    <p>
      We will keep your Personal Information for as long as it remains necessary for the identified purpose or as required by law, which may extend beyond
      the termination of Our relationship with you. We may retain certain data as necessary to prevent fraud or future abuse, or for legitimate business
      purposes, such as analysis of aggregated, non-personally-identifiable data, account recovery, or if required by law. All retained Personal
      Information will remain subject to the terms of this Privacy Policy.
    </p>
    <p>
      We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration,
      disclosure or destruction of your Personal Information, username, password, transaction information and data stored on Our Site.
    </p>
    <h2 class="small-title">Access, Correction and Accuracy</h2>
    <p>
      You have the right to access the Personal Information We hold about you in order to verify the Personal Information We have collected in respect to
      you and to have a general account of Our uses of that information. Upon receipt of your written request, We will provide you with a copy of your
      Personal Information, although in certain limited circumstances, and as permitted under law, We may not be able to make all relevant information
      available to you, such as where that information also pertains to another user. In such circumstances We will provide reasons for the denial to you
      upon request. We will endeavor to deal with all requests for access and modifications in a timely manner.
    </p>
    <p>
      We will make every reasonable effort to keep your Personal Information accurate and up to date, and we will provide you with mechanisms to update,
      correct, delete or add to your Personal Information as appropriate. As appropriate, this amended Personal Information will be transmitted to those
      parties to which We are permitted to disclose your information. Having accurate Personal Information about you enables Us to give you the best
      possible service.
    </p>
    <h2 class="small-title">Residents of the European Economic Area (EEA)</h2>
    <p>
      Showadz generally processes Personal Information in order to fulfill contracts We have with Our customers and Users and to pursue Our legitimate
      business interests listed above. Otherwise, Showadz will obtain express consent from an individual in respect of the processing of Personal
      Information if required by law to do so.
    </p>
    <p>
      Individuals located in the EEA have certain rights under European law (including under the General Data Protection Regulation) with respect to
      Personal Information, including the right to request access to, obtain, correct, amend, delete, or limit the use of your personal data. Individual
      Users, customers or prospective customers located in to the EEA who wish to exercise these rights, should contact Showadz using the contact
      information below. In circumstances where Our customer is the data controller, Showadz may be required to refer your request to Our customer with
      whom the User has a relationship.
    </p>
    <p>
      Individuals also have the right to make complaints to regulatory authorities in respect of Our privacy practices. Showadz has the discretion to
      update this Privacy Policy at any time. When We do, We will post a notification on the main page of Our Site, revise the updated date at the bottom
      of this page, and send Users an email. We encourage Users to frequently check this page for any changes to stay informed about how We are helping to
      protect the Personal Information We collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and
      become aware of modifications.
    </p>
    <h2 class="small-title">Your acceptance of these terms</h2>
    <p>
      By using this Site and Service, you signify your acceptance of this Privacy Policy and Our Terms of Service. If you do not agree to this Privacy
      Policy, please do not use Our Site or the Services. Your continued use of the Site following the posting of changes to this Privacy Policy will be
      deemed your acceptance of those changes.
    </p>
    <h2 class="small-title">Contacting us</h2>
    <p>
      If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this Site, please contact Our support staff
      who will put you in touch with our privacy officer at:
    </p>
    <p>Showadz<br />app.showadz.io<br />776 rue labelle<br />Saint-Jérôme J7Z 5M3 Canada<br />Email: julien@showadz.io</p>
  </div>
</template>

<script>
export default {
  head: function () {
    return {
      title: {
        inner: this.currentProduct ? this.currentProduct.name : 'Privacy Policy',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} article details page`,
          id: 'desc',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
@import '@/theme/typography.scss';

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 25px 50px;
  background-color: #fff;

  .logo {
    width: 145px;
    display: block;
  }
}

.page-wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5vw 0;

  h1 {
    color: $dark-blue;
    margin-bottom: 20px;
  }

  h2 {
    color: $dark-blue;
    margin-bottom: 10px;
    margin-top: 30px;
  }

  .small-title {
    font-size: 16px;
  }

  p {
    color: $dark-grey;
    margin-bottom: 15px;
  }

  ul li {
    color: $dark-grey;
  }
}
</style>
